import { Link } from "react-router-dom";

const sizeClasses = {
  xs: "w-6 h-6 text-xs",
  sm: "w-8 h-8 text-sm",
  md: "w-10 h-10 text-sm",
  lg: "w-16 h-16 text-xl",
  xl: "w-24 h-24 text-3xl",
};

const Avatar = ({ user, size = "md", linkToProfile = false, className = "" }) => {
  const initial = (user?.first_name || "?").charAt(0).toUpperCase();
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  const avatar = user?.profile_picture_url ? (
    <img
      src={user.profile_picture_url}
      alt={user.first_name || "User"}
      className={`${sizeClass} rounded-full object-cover ${className}`}
    />
  ) : (
    <div className={`${sizeClass} bg-blue-500 rounded-full flex items-center justify-center text-white font-bold ${className}`}>
      {initial}
    </div>
  );

  if (linkToProfile && user?.id) {
    return <Link to={`/profile/${user.id}`}>{avatar}</Link>;
  }
  return avatar;
};

export default Avatar;
